import './src/styles/global.css'
import PageWrapper from './src/system/utils/PageWrapper'

export const wrapPageElement = PageWrapper
